
import React, { useEffect } from "react";
import { areas } from "../../helpers/areas";
import { MenuItem } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { SelectValidator } from 'react-material-ui-form-validator';
import { traerConfiguracionPorCategoria } from "../../actions/configuraciones/ConfiguracionCategoria";
import { MOTIVO_BAJA_AFI, PARENTESCOS, TIPO_AFILIACION } from "../../utils/constants";

export const CboTipoAfiliacion = (props) => {
  const afiliaciones = useSelector(state => state.tipoAfiliaciones);
  const { items: configCategorias } = useSelector(state => state.configuracionesCategoria);
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (props.idCategoria != null) {
      dispatch(traerConfiguracionPorCategoria(props.idCategoria));
    }
  }, [afiliaciones.items, dispatch, props.idCategoria]);

  return (
    <>
     
      <SelectValidator
        value={props.valor || ""}
        name="id_tipo_afiliacion"
        disabled={(
          props.parentesco !== PARENTESCOS.TITULAR || 
          (props.idPanel === 'idTabConsulta' && !props.reactivacion) || 
          props.fromBandejaFamiliar || 
          (props.fromBandeja && idAreaUsuario === areas.Nacional)
          ) ? true : false}
        onChange={(e) => {
          //props.manejadorInputChange(e);
          

          if((e.target.value === TIPO_AFILIACION.PASANTE 
            || e.target.value === TIPO_AFILIACION.TEMPORARIO)
            && (props.tabIngreso || props.reactivacion || props.esModificacion)
            && props.parentesco === PARENTESCOS.TITULAR) {
              props.setearVariosValores({
                id_motivo_baja: e.target.value === TIPO_AFILIACION.PASANTE ? MOTIVO_BAJA_AFI.FIN_DE_CONTRATO : MOTIVO_BAJA_AFI.TRABAJADOR_TEMPORADA_RESERVA_PUESTO,
                id_tipo_afiliacion: e.target.value
              });
            } else {
              if(props.tabIngreso || props.reactivacion || props.esModificacion){

                if(props.reactivacion) {
                  props.setearVariosValores({
                    id_tipo_afiliacion: e.target.value,
                    fecha_fin_cobertura: null
                  });
                } else {
                  props.setearVariosValores({
                    id_motivo_baja: null,
                    id_tipo_afiliacion: e.target.value,
                    fecha_fin_cobertura: null
                  });
                }


                /*
                if(props.fechaBaja !== ""){
                  props.setearVariosValores({
                    id_tipo_afiliacion: e.target.value,
                    fecha_fin_cobertura: null
                  });
                } else {
                  props.setearVariosValores({
                    id_motivo_baja: null,
                    id_tipo_afiliacion: e.target.value,
                    fecha_fin_cobertura: null
                  });
                }
                */
              } else {
                props.manejadorInputChange(e);
              }
            }
            

        }}
        label="Tipo Relacion"
        fullWidth={true}
        margin="normal"
        validators={['required']}
        errorMessages={['Seleccione una opcion']}
      >
        <MenuItem value="">
          <em>Seleccione</em>
        </MenuItem>
        {configCategorias.map((t) => (
          t.marcado === true && <MenuItem key={t.idTipoAfiliacion} value={t.idTipoAfiliacion}>
            {t.tipoAfiliacion.descripcion_afiliacion}
          </MenuItem>
        ))}
      </SelectValidator>
    </>
  );
};
